import { InjectionToken } from '@angular/core';
import { ApiConfiguration } from './api-configuration';
import { SupportWidgetConfig } from './support-widget-config';

/**
 * Shape of an app's active environment as consumed by shared, app-agnostic code
 * (e.g. LocalDevAutoLoginService). Only `name` is required today; the rest is
 * optional so both `environmentUser` and `environmentAdmin` satisfy it.
 */
export interface AppEnvironment {
  name: string;
  isProduction?: boolean;
  production?: boolean;
  apiConfiguration?: ApiConfiguration;
  languagesDefault?: string;
  languagesAvailable?: string[];
  /** Absent in an app that does not run the support widget. */
  support?: SupportWidgetConfig;
}

/**
 * DI token for the active app environment. Each app provides its own
 * (user → `environmentUser`, admin → `environmentAdmin`) so shared services are
 * not bound to a specific app. Defaults to a production-like environment when no
 * app provides one (e.g. in isolated unit tests).
 */
export const APP_ENVIRONMENT = new InjectionToken<AppEnvironment>('APP_ENVIRONMENT', {
  providedIn: 'root',
  factory: () => ({ name: 'production' }),
});
